import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { amazonService } from '../utils/amazonService';

export const AMAZON_CONNECTION_QUERY_KEY = ['amazon-connection'] as const;

export function useAmazonConnection() {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: [...AMAZON_CONNECTION_QUERY_KEY, user?.id],
    queryFn: () => amazonService.getConnections(),
    enabled: !!user,
    staleTime: 60 * 1000,
    retry: 1,
  });

  const connections = query.data ?? [];
  const isConnected = connections.some((connection) => connection.is_active);

  return {
    isConnected,
    isLoading: query.isLoading,
    connections,
  };
}
